(function() {
    'use strict';
    angular
        .module('dialysisApp')
        .factory('DialyserType', DialyserType);

    DialyserType.$inject = ['$resource'];

    function DialyserType ($resource) {
        var resourceUrl =  'api/dialyser-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
